import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { INavLink, Stack, StackItem } from '@fluentui/react';
import NavbarTopComponent from '../../components/navbar-top/navbar-top.component';
import NavbarLeftComponent from '../../components/navbar-left/navbar-left';
import LoaderComponent from '../../components/loader/loader.component';

import IAuth from '../../hooks/auth/IAuth';
import ItemCliente from '../../models/ItemCliente';

interface IPrivateLayoutProps {
    auth: IAuth;
    onLogout: () => void;
    menuItems: INavLink[];
    children: JSX.Element;
};

const PrivateLayout = (props: IPrivateLayoutProps) => {
    const navigate = useNavigate();
    
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const script1 : HTMLScriptElement = document.createElement('script');
        script1.src = "https://www.googletagmanager.com/gtag/js?id=G-4GG77XYHG6";
        script1.async = true;
        document.body.appendChild(script1);

        const script2 : HTMLScriptElement = document.createElement('script');
        script2.append("window.dataLayer = window.dataLayer || []; function gtag() { dataLayer.push(arguments); } gtag('js', new Date()); gtag('config', 'G-4GG77XYHG6');");
        document.body.appendChild(script2);

        const script3 : HTMLScriptElement = document.createElement('script');
        script3.append("(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; h._hjSettings={hjid:3268939,hjsv:6}; a=o.getElementsByTagName('head')[0]; r=o.createElement('script');r.async=1; r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; a.appendChild(r); })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');");
        document.body.appendChild(script3);

        return () => {
            document.body.removeChild(script1);
            document.body.removeChild(script2);
            document.body.removeChild(script3);
        };
    }, []);

    useEffect(() => {
        if (!props.auth.user) {
            navigate('/');
        }
        else {
            let espacio : string | undefined = props.auth.user.Clientes.find((c: ItemCliente) => c.CodigoCliente === props.auth.user?.CodigoCliente)?.Nombre;
            if (espacio) {
                document.title = `${document.title} - ${espacio}`;
            }
        }
    }, [props.auth.user, navigate]);

    return (
        props.auth.user ? (
            <div className="container-fluid h-100 p-0 d-flex flex-column">
                <Stack className='row align-items-center m-0'>
                    <StackItem className='col-12 p-0'>
                        <NavbarTopComponent user={props.auth.user} onLogout={props.onLogout} menuItems={props.menuItems} setLoading={setLoading} />
                    </StackItem>
                </Stack>
                <Stack horizontal={true} className='d-flex flex-row flex-fill overflow-hidden'>
                    {
                        !props.auth.user.ModoBienvenida ? (
                            <StackItem className="h-100 p-0">
                                <NavbarLeftComponent menuItems={props.menuItems} />
                            </StackItem>
                        ) : (
                            null
                        )
                    }
                    <StackItem className="flex-fill h-100 p-0 overflow-hidden">
                        {props.children}
                    </StackItem>
                </Stack>
                <LoaderComponent loading={loading} />
            </div>
        ) : (
            null
        )
    );
};

export default PrivateLayout;
